import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { EXTERNAL_USER_ROLES } from "../constants";

export const useExternalUserRedirect = () => {
  const history = useHistory();
  const userDetails = useSelector((state) => state.user);

  useEffect(() => {
    if (!userDetails?.role) return;

    const isExternalUser = EXTERNAL_USER_ROLES.includes(userDetails.role);

    if (userDetails.role !== "MedlineAdministrator" && userDetails.customerSettings?.ne1Wms === 0 && isExternalUser) {
      history.push("/learnMore");
    }
  }, [userDetails, history]);
};
